import React from "react";

export function Privacypolicy() {
	return (
		<div className=" p-6 sm:p-8 animate-fadeIn" style={{
        background: 'linear-gradient(50deg, #E5E7EB 50%, #E5E7EB 50%, #008C9E 50%, #008C9E 100%)'
      }}>
			<div className="bg-white rounded-2xl shadow p-6 sm:p-10">
				<h1 className="text-2xl sm:text-3xl font-bold text-gray-900 mb-1">Privacy Policy</h1>
				<p className="text-sm text-gray-500 mb-6 font-medium">Last Updated: January 2026</p>

				<div className="space-y-6 text-gray-700">
					<p>
						PixelisApp ("we", "our", or "us") is a clinical photo management
						application designed for medical professionals to securely capture,
						store, and compare before-and-after treatment images. We are
						committed to protecting the privacy, confidentiality, and security
						of user and patient data. This Privacy Policy explains how
						information is collected, used, stored, and protected when
						PixelisApp is used.
					</p>

					<div>
						<h2 className="text-lg font-semibold text-gray-900 mb-2">1. Information We Collect</h2>
						<h3 className="font-medium">a. User Information</h3>
						<ul className="list-disc ml-6 mt-2 text-gray-700">
							<li>Name</li>
							<li>Email address</li>
							<li>Phone number</li>
							<li>Role (Doctor / Staff)</li>
						</ul>

						<h3 className="font-medium mt-4">b. Patient Information</h3>
						<ul className="list-disc ml-6 mt-2 text-gray-700">
							<li>Patient identifiers (name or patient ID)</li>
							<li>Clinical photographs (before and after treatment images)</li>
							<li>Diagnosis and treatment-related information</li>
							<li>Visit date and time</li>
							<li>Digitally signed consent records</li>
						</ul>

						<h3 className="font-medium mt-4">c. Technical Information</h3>
						<ul className="list-disc ml-6 mt-2 text-gray-700">
							<li>Device type and operating system</li>
							<li>Application usage logs required for security and performance</li>
						</ul>
					</div>

					<div>
						<h2 className="text-lg font-semibold text-gray-900 mb-2">2. How We Use Information</h2>
						<p className="text-gray-700">
							The information collected is used strictly for clinical documentation
							and treatment comparison, secure storage and retrieval of medical
							images, user authentication and role-based access control,
							maintaining legal compliance through consent records, and improving
							application reliability and performance.
						</p>
						<p className="text-gray-700 mt-2">PixelisApp does not use patient or user data for advertising, marketing, or profiling purposes.</p>
					</div>

					<div>
						<h2 className="text-lg font-semibold text-gray-900 mb-2">3. Data Storage and Security</h2>
						<ul className="list-disc ml-6 text-gray-700">
							<li>All clinical images and data are stored securely using encrypted storage systems.</li>
							<li>Original clinical photographs remain unmodified to preserve medical accuracy.</li>
							<li>Access to data is restricted through role-based permissions.</li>
							<li>Reasonable technical and organizational measures are implemented to protect data from unauthorized access, loss, or misuse.</li>
						</ul>
					</div>

					<div>
						<h2 className="text-lg font-semibold text-gray-900 mb-2">4. Consent and Legal Compliance</h2>
						<ul className="list-disc ml-6 text-gray-700">
							<li>Digital patient consent is mandatory before capturing or storing clinical photographs.</li>
							<li>Consent records are time-stamped and securely linked to patient profiles.</li>
							<li>Consent usage follows applicable medical, ethical, and data protection regulations.</li>
							<li>The responsibility for obtaining valid patient consent lies with the medical professional using PixelisApp.</li>
						</ul>
					</div>

					<div>
						<h2 className="text-lg font-semibold text-gray-900 mb-2">5. Data Sharing</h2>
						<p className="text-gray-700">PixelisApp does not sell, rent, or trade personal or patient data.</p>
						<p className="text-gray-700 mt-2">Data may be shared only:</p>
						<ul className="list-disc ml-6 text-gray-700">
							<li>When required by law or legal process</li>
							<li>With authorized service providers strictly for application functionality (such as secure cloud storage), under confidentiality obligations</li>
						</ul>
					</div>

					<div>
						<h2 className="text-lg font-semibold text-gray-900 mb-2">6. Data Retention</h2>
						<p className="text-gray-700">Data is retained for as long as the account remains active or as required for clinical, legal, or regulatory purposes. Upon account termination, data handling will follow applicable legal and regulatory requirements.</p>
					</div>

					<div>
						<h2 className="text-lg font-semibold text-gray-900 mb-2">7. User Responsibilities</h2>
						<ul className="list-disc ml-6 text-gray-700">
							<li>Maintaining the confidentiality of their login credentials</li>
							<li>Ensuring patient consent is obtained before capturing or storing images</li>
							<li>Complying with applicable medical and data protection laws</li>
						</ul>
					</div>

					<div>
						<h2 className="text-lg font-semibold text-gray-900 mb-2">8. Children’s Privacy</h2>
						<p className="text-gray-700">PixelisApp is intended exclusively for use by medical professionals. It is not designed for use by children or the general public.</p>
					</div>

					<div>
						<h2 className="text-lg font-semibold text-gray-900 mb-2">9. Changes to This Policy</h2>
						<p className="text-gray-700">This Privacy Policy may be updated from time to time. Any changes will be reflected with an updated revision date.</p>
					</div>

					<div>
						<h2 className="text-lg font-semibold text-gray-900 mb-2">10. Contact Information</h2>
						<p className="text-gray-700">If you have any questions or concerns regarding this Privacy Policy or data handling practices, please contact us at: <strong className="text-gray-900">support@ksoftpl.com</strong></p>
					</div>
				</div>
			</div>
		</div>
	);
}

export default Privacypolicy;


